export default "/images/7a6f889b7966fc9279b89a435f676016.avif";